<template>
  <div class="settings">
    <toolbar
      backRoute="/dashboard"
      title="Settings"
      :addButton="true"
      actionButtonLabel="Save"
      actionButtonIcon="save"
      :actionButtonCallback="validateForm" />

    <validation-observer
      ref="settings-form"
      tag="form">
      <fieldset class="mt-5 pb-0">
        <legend>Documents Warning Periods</legend>

        <d-row>
          <d-col cols="6">
            <fieldset class="mt-2 mb-3">
              <legend class="mb-4">
                <small>
                  <strong>
                    Crew and passengers
                  </strong>
                </small>
              </legend>

              <d-row class="pb-2">
                <d-col cols="4">
                  <label class="pt-1 text-right w-100">
                    Others:
                  </label>
                </d-col>

                <d-col cols="8">
                  <validation-provider
                    rules="required"
                    name="person_other"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.person_other"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>

              <d-row class="pb-2">
                <d-col cols="4">
                  <label class="pt-1 text-right w-100">
                    Passport:
                  </label>
                </d-col>

                <d-col cols="8">
                  <validation-provider
                    rules="required"
                    name="person_passport"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.person_passport"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>

              <d-row class="pb-2">
                <d-col cols="4">
                  <label class="pt-1 text-right w-100">
                    License:
                  </label>
                </d-col>

                <d-col cols="8">
                  <validation-provider
                    rules="required"
                    name="person_licence"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.person_licence"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>

              <d-row class="pb-2">
                <d-col cols="4">
                  <label class="pt-1 text-right w-100">
                    Visas:
                  </label>
                </d-col>

                <d-col cols="8">
                  <validation-provider
                    rules="required"
                    name="person_visa"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.person_visa"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>
            </fieldset>
          </d-col>

          <d-col cols="6">
            <fieldset class="mt-2 mb-3">
              <legend class="mb-4">
                <small>
                  <strong>
                    Aircrafts
                  </strong>
                </small>
              </legend>

              <d-row class="pb-2">
                <d-col cols="6">
                  <label class="pt-1 text-right w-100">
                    Insurance:
                  </label>
                </d-col>

                <d-col cols="6">
                  <validation-provider
                    rules="required"
                    name="aircraft_insurance"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.aircraft_insurance"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>

              <d-row class="pb-2">
                <d-col cols="6">
                  <label class="pt-1 text-right w-100">
                    Radio:
                  </label>
                </d-col>

                <d-col cols="6">
                  <validation-provider
                    rules="required"
                    name="aircraft_radio"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.aircraft_radio"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>

              <d-row class="pb-2">
                <d-col cols="6">
                  <label class="pt-1 text-right w-100">
                    Certificate of airworthiness:
                  </label>
                </d-col>

                <d-col cols="6">
                  <validation-provider
                    rules="required"
                    name="aircraft_certificate"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.aircraft_certificate"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>

              <d-row class="pb-2">
                <d-col cols="6">
                  <label class="pt-1 text-right w-100">
                    Maintenance:
                  </label>
                </d-col>

                <d-col cols="6">
                  <validation-provider
                    rules="required"
                    name="aircraft_maintenance"
                    v-slot="{ errors }">
                    <d-input-group
                      append="Days"
                      style="width: 150px;">
                      <d-input
                        type="number"
                        min="0"
                        step="1"
                        v-model="data.aircraft_maintenance"
                        :state="errors.length ? 'invalid' : null"
                        style="text-align: right;" />
                    </d-input-group>
                  </validation-provider>
                </d-col>
              </d-row>
            </fieldset>
          </d-col>
        </d-row>
      </fieldset>

      <fieldset class="mt-5">
        <legend>E-mail notifications</legend>

        <div class="form-group mt-4">
          <label for="seats">Slot notifications for Geneva Monitoring:</label>
          <validation-provider
            rules="email"
            name="notification_slot_email"
            v-slot="{ errors }">
            <d-input
              v-model="data.notification_slot_email"
              name="notification_slot_email"
              type="email"
              placeholder="E-mail address"
              :state="errors.length ? 'invalid' : null" />
          </validation-provider>
        </div>
      </fieldset>

      <fieldset class="mt-5">
        <legend>Flight - General declaration PDF</legend>

        <div class="form-group mt-4">
          <label for="seats">Flight general declaration statement (I):</label>
          <d-textarea
            :rows="8"
            :value.prop="data.flight_general_declaration_statement_1"
            v-model="data.flight_general_declaration_statement_1" />
        </div>

        <div class="form-group mt-4">
          <label for="seats">Flight general declaration statement (II):</label>
          <d-textarea
            :rows="8"
            :value.prop="data.flight_general_declaration_statement_2"
            v-model="data.flight_general_declaration_statement_2" />
        </div>

        <div class="form-group mt-4">
          <label for="seats">Flight general declaration statement (III):</label>
          <d-textarea
            :rows="8"
            :value.prop="data.flight_general_declaration_statement_3"
            v-model="data.flight_general_declaration_statement_3" />
        </div>
      </fieldset>

      <fieldset class="mt-5">
        <legend>Handling request PDF</legend>

        <div class="form-group mt-4">
          <label for="seats">Handling request description:</label>
          <d-textarea
            :rows="8"
            :value.prop="data.handling_request_description"
            v-model="data.handling_request_description" />
        </div>
      </fieldset>

      <israel-contact-persons
        v-if="allDataLoaded" />
    </validation-observer>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';
import IsraelContactPersons from './../components/form-parts/IsraelContactPersons.vue';

export default {
  name: 'settings',
  components: {
    'israel-contact-persons': IsraelContactPersons
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      data: {
        aircraft_insurance: 0,
        aircraft_radio: 0,
        aircraft_certificate: 0,
        aircraft_maintenance: 0,
        flight_general_declaration_statement_1: '',
        flight_general_declaration_statement_2: '',
        flight_general_declaration_statement_3: '',
        handling_request_description: '',
        notification_slot_email: '',
        person_other: 0,
        person_passport: 0,
        person_licence: 0,
        person_visa: 0
      },
      loadError: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/system/settings/item',
        id: null,
        instanceFields: [
          'aircraft_insurance',
          'aircraft_radio',
          'aircraft_certificate',
          'aircraft_maintenance',
          'flight_general_declaration_statement_1',
          'flight_general_declaration_statement_2',
          'flight_general_declaration_statement_3',
          'handling_request_description',
          'notification_slot_email',
          'person_other',
          'person_passport',
          'person_licence',
          'person_visa'
        ],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['settings-form'], this.save);
    },
    save () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/system/settings/update',
        formData: this.data,
        successTitle: 'Settings saved!',
        successText: 'The settings has been successfully saved!',
        errorTitle: 'An error occurred!',
        errorText: 'The operation not finished successfully. Please try again.',
        successAction: () => {
          this.$router.push('/dashboard/');
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
